import React, { Component } from 'react';
import { isSet } from '../../../../Utils/CommonFunctions';
import SwitchItems from '../../../FormBuilder/Builder/FormInputs/SwitchItems';
import {ErrorBlock} from '../../../../hoc/FormInput';
// import {isSet} from '../../../../Utils/CommonFunctions';
// import ToolTipWrapper from '../../../../hoc/Wrp/ToolTipWrapper';

class InputElement extends Component {
  
    componentDidMount(){
      // console.log(this.props);
    }
    render () {
      const {colData,id,header} = this.props;
      const {item,changeHandler,section } = colData;
      if(isSet(colData.item,null)===null){ 
        return(
          <td key={"column"+id} style={{minWidth:'250px'}} {...header.attributes}></td>
        ); 
      }
      try{
        return(
          <td key={"column"+id} style={{minWidth:'250px'}} {...header.attributes}>
              <SwitchItems 
                  {...this.props} 
                  {...this.state} 
                  key={id}
                  withoutBlock={true}
                  onChangeInputAction={changeHandler}
                  modType={'ADDFORM'}
                  item={item} 
                  isLabel={false}
                  section={section} />
                  <div className="col-12">
                    <ErrorBlock message={isSet(colData.validation,'')}/>
                  </div>
          </td>
       );
      }catch(e){

      }
        
    }
}

export default InputElement;